<template>
  <div class="wallet-card">
    <p class="header">
      <slot name="header" />
    </p>
    <div class="body">
      <slot name="body" />
    </div>
    <div class="detail">
      <p class="detail__toggle">
        <button class="button" @click="isDetail = !isDetail">Details</button>
      </p>

      <p v-if="isDetail" class="detail__data">
        <slot name="detail" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SteamCakelpFarmingUnlockableWalletCard",
  data() {
    return {
      isDetail: false,
    };
  },
  methods: {
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.wallet-card {
  background: var(--color_bg_parts);
  border-radius: 20px;
  box-shadow: $box-shadow;
}
.header {
  position: relative;
  border-bottom: 1px solid $color-border;
  margin-bottom: 24px;
  display: grid;
  grid-column-gap: 16px;
  height: 136px;
  padding: 32px 24px 24px;
  grid-template-columns: 1fr 1fr;
}
.body {
  margin: auto 40px 24px;
}
.detail {
  border-top: 1px solid $gray2;
  padding: 12px 0;
  margin: auto 40px;

  &__toggle {
    text-align: center;

    .button {
      font-size: 1.2rem;
      font-weight: 600;
      border: none;
      background: none;
    }
  }
  &__data {
    margin-top: 24px;
    font-size: 1.2rem;
    color: $color-font-note;
  }
}
</style>